import EventEmitter from "eventemitter3";
import { RopPortfolioSSEData } from "../models/portfolio.model";

type DadosPortfolioRealTimeEvent = {
  connected: () => void;
  reconnecting: (reason?: string) => void;
  disconnected: (reason?: string) => void;
  error: (errorMessage: string) => void;
  portfolioUpdate: (portfolioUpdate: RopPortfolioSSEData) => void;
};

export class DadosPortfolioEventManager extends EventEmitter<DadosPortfolioRealTimeEvent> {
  private readonly _eventSource: EventSource;

  public constructor(
    userId: string,
    clientId: string,
    token: string,
    clusterId?: string
  ) {
    console.debug("Criando DadosPortfolioEventManager");
    super();

    const apiBaseUrl = import.meta.env.VITE_LINK_API;
    if (!apiBaseUrl) {
      console.warn("API BASE URL não definida");
    }

    const sseUrl = new URL(
      "/api/v1/DadosPortfolio",
      import.meta.env.VITE_LINK_API
    );
    sseUrl.searchParams.set("userId", userId);
    sseUrl.searchParams.set("clientId", clientId);
    sseUrl.searchParams.set("token", token);
    if (clusterId) {
      sseUrl.searchParams.set("clusterId", clusterId);
    }

    this._eventSource = new EventSource(sseUrl);
    this._eventSource.onopen = this.handleOpen.bind(this);
    this._eventSource.onerror = this.handleError.bind(this);
    this._eventSource.onmessage = this.handleMessageWithoutEvent.bind(this);
    this._eventSource.addEventListener(
      "ropCardUpdate",
      this.handlePortfolioUpdate.bind(this)
    );
    this._eventSource.addEventListener(
      "clienterror",
      this.handleClientError.bind(this)
    );
  }

  private handleOpen(_ev: Event) {
    // console.debug("Lendo Open", _ev);
    this.emit("connected");
  }

  private handleError(_ev: Event) {
    // console.debug("Lendo Error", _ev);
    this.emit("reconnecting");
  }

  private handleMessageWithoutEvent(event: MessageEvent<unknown>) {
    console.debug("Lendo Message sem evento", event);
  }

  private handlePortfolioUpdate(event: MessageEvent<unknown>) {
    // console.debug("Lendo evento PortfolioUpdate", event);
    if (!event.data || typeof event.data !== "string") {
      console.warn(
        "Evento PortfolioUpdate vazio ou com tipo inválido",
        event
      );
      return;
    }

    let portfolioData: RopPortfolioSSEData;
    try {
      const parsedEvtData = JSON.parse(event.data);
      portfolioData = parsedEvtData;
    } catch (error) {
      console.error(
        error,
        "Erro ao fazer parse do evento handlePortfolioUpdate",
        event
      );
      return;
    }

    // console.debug("Emitindo evento portfolioUpdate", portfolioData);
    this.emit("portfolioUpdate", portfolioData);
  }

  private handleClientError(event: MessageEvent<unknown>) {
    // console.debug("Lendo evento ClientError", event);
    this.disconnect("Erro nas informações do cliente tempo real");

    if (!event.data || typeof event.data !== "string") {
      console.warn("Evento ClientError vazio ou com tipo inválido", event);
      return;
    }

    const errorMessage = event.data;
    this.emit("error", errorMessage);
  }

  private disconnect(reason?: string) {
    console.debug("Desconectando DadosPortfolioEventManager", reason);
    this.emit("disconnected", reason);
    this._eventSource.close();
  }

  public destroy() {
    console.debug("Destruindo DadosPortfolioEventManager");
    this.disconnect("Cliente cancelou a conexão");
    this.removeAllListeners();
  }
}
